export const menuCategories = [
  {
    id: 'broodjes',
    name: { nl: 'Broodjes', en: 'Sandwiches' },
    icon: '🥖',
    items: [
      { id: 1, name: 'Br. Kipdöner', price: 7.50 },
      { id: 2, name: 'Br. Kipfilet', price: 8.50 },
      { id: 3, name: 'Br. Kalfsdöner', price: 8.50 },
      { id: 4, name: 'Br. Lamsshoarma', price: 9.00 },
      { id: 5, name: 'Br. Lamsshoarma met kaas', price: 10.00 },
      { id: 6, name: 'Br. Shoarma klein', price: 9.00 },
      { id: 7, name: 'Br. Shoarma groot', price: 10.00 },
      { id: 8, name: 'Br. Köfte', price: 8.00 },
      { id: 9, name: 'Br. Falafel', price: 7.00 },
      { id: 10, name: 'Br. Mexicano', price: 4.50 },
      { id: 11, name: 'Br. Frikandel', price: 3.50 }
    ]
  },
  {
    id: 'stokbroodKebab',
    name: { nl: 'Stokbrood Kebab', en: 'Baguette Kebab' },
    icon: '🥙',
    items: [
      { id: 12, name: 'Kipdöner', price: 9.50 },
      { id: 13, name: 'Kalfsdöner', price: 10.00 },
      { id: 14, name: 'Kipfilet', price: 10.50 },
      { id: 15, name: 'Lamsshoarma', price: 11.00 },
      { id: 16, name: 'Köfte', price: 9.00 },
      { id: 17, name: 'Falafel', price: 8.00 },
      { id: 18, name: 'Extra Kaas', price: 0.50 }
    ]
  },
  {
    id: 'bakjeDoner',
    name: { nl: 'Bakje Döner', en: 'Döner Box' },
    icon: '🥡',
    items: [
      { id: 19, name: 'Kalfsdöner met extra dönervlees', price: 11.00 },
      { id: 20, name: 'Kalfsdöner met paprika en ui', price: 12.00 },
      { id: 21, name: 'Kipdöner met extra dönervlees', price: 10.00 },
      { id: 22, name: 'Kipdöner met paprika en ui', price: 11.00 }
    ]
  },
  {
    id: 'donerbox',
    name: { nl: 'Dönerbox', en: 'Döner Box' },
    icon: '📦',
    items: [
      { id: 23, name: 'Kipdöner box klein', price: 7.00 },
      { id: 24, name: 'Kipdöner box groot', price: 8.00 },
      { id: 25, name: 'Kalfsdöner box klein', price: 7.50 },
      { id: 26, name: 'Kalfsdöner box groot', price: 8.50 },
      { id: 27, name: 'Lamsshoarma box klein', price: 8.00 },
      { id: 28, name: 'Lamsshoarma box groot', price: 9.00 }
    ]
  },
  {
    id: 'schotels',
    name: { nl: 'Schotels', en: 'Plates' },
    icon: '🍽️',
    items: [
      { id: 29, name: 'Shoarma', price: 16.50 },
      { id: 30, name: 'Shoarma Speciaal (met paprika, champignons & ui)', price: 17.50 },
      { id: 31, name: 'Shoarma Tagin (met paprika, champignons, ui & kaas)', price: 17.50 },
      { id: 32, name: 'Kipfilet (met paprika, champignons, ui & kaas)', price: 15.50 },
      { id: 33, name: 'Kip Hawaï (met ananas)', price: 16.50 },
      { id: 34, name: 'Shaslick', price: 18.00 },
      { id: 35, name: 'Kalfsdöner kebab', price: 15.00 },
      { id: 36, name: 'Kipdöner kebab', price: 14.00 },
      { id: 37, name: 'Falafel', price: 12.00 }
    ]
  },
  {
    id: 'turksePizza',
    name: { nl: 'Turkse Pizza\'s', en: 'Turkish Pizzas' },
    icon: '🍕',
    items: [
      { id: 38, name: 'Turkse Pizza', price: 4.50 },
      { id: 39, name: 'Turkse Pizza Kaas', price: 5.50 },
      { id: 40, name: 'Turkse Pizza Vega', price: 5.50 },
      { id: 41, name: 'Turkse Pizza Kipfilet', price: 10.00 },
      { id: 42, name: 'Turkse Pizza Kalfsdöner', price: 9.00 },
      { id: 43, name: 'Turkse Pizza Kipdöner', price: 8.50 },
      { id: 44, name: 'Turkse Pizza Lamsshoarma', price: 10.00 },
      { id: 45, name: 'Turkse Pizza Sucuk', price: 8.00 },
      { id: 46, name: 'Turkse Pizza Kaas Sucuk', price: 9.00 }
    ]
  },
  {
    id: 'durum',
    name: { nl: 'Dürüm\'s', en: 'Dürüm Wraps' },
    icon: '🌯',
    items: [
      { id: 47, name: 'Dürüm Kipdöner', price: 8.50 },
      { id: 48, name: 'Dürüm Kalfsdöner', price: 9.00 },
      { id: 49, name: 'Dürüm Kipfilet', price: 9.00 },
      { id: 50, name: 'Dürüm Lamsshoarma', price: 10.00 },
      { id: 51, name: 'Dürüm Köfte', price: 8.50 },
      { id: 52, name: 'Dürüm Falafel', price: 8.00 },
      { id: 53, name: 'Extra Kaas', price: 1.00 }
    ]
  },
  {
    id: 'kapsalon',
    name: { nl: 'Kapsalon', en: 'Kapsalon' },
    icon: '🍟',
    items: [
      { id: 54, name: 'Kipdöner', price: 12.00 },
      { id: 55, name: 'Kipfilet', price: 14.50 },
      { id: 56, name: 'Kalfsdöner', price: 13.00 },
      { id: 57, name: 'Lamsshoarma', price: 14.50 },
      { id: 58, name: 'Vegetarisch', price: 11.00 },
      { id: 59, name: 'Rijst Kipdöner', price: 13.00 },
      { id: 60, name: 'Rijst Kipfilet', price: 15.50 },
      { id: 61, name: 'Rijst Kalfsdöner', price: 14.00 },
      { id: 62, name: 'Rijst Lamsshoarma', price: 15.50 },
      { id: 63, name: 'Rijst Vegetarisch', price: 12.00 }
    ]
  },
  {
    id: 'hamburger',
    name: { nl: 'Hamburger', en: 'Burger' },
    icon: '🍔',
    items: [
      { id: 64, name: 'Hamburger Los', price: 7.50 },
      { id: 65, name: 'Hamburger Menu', price: 12.00 },
      { id: 66, name: 'Kipburger Los', price: 7.00 },
      { id: 67, name: 'Kipburger Menu', price: 11.50 }
    ]
  },
  {
    id: 'pitas',
    name: { nl: 'Pita\'s', en: 'Pitas' },
    icon: '🫓',
    items: [
      { id: 68, name: 'Kaas', price: 4.00 },
      { id: 69, name: 'Kaas Ham (Kalkoen)', price: 4.50 },
      { id: 70, name: 'Kaas Salami', price: 4.50 },
      { id: 71, name: 'Kaas Ananas', price: 4.50 },
      { id: 72, name: 'Hawaï', price: 5.00 },
      { id: 73, name: 'Gezond', price: 5.00 }
    ]
  },
  {
    id: 'patatFrisdranken',
    name: { nl: 'Patat & Frisdranken', en: 'Fries & Drinks' },
    icon: '🍟',
    items: [
      { id: 74, name: 'Patat', price: 4.00 },
      { id: 75, name: 'Patat Met', price: 4.50 },
      { id: 76, name: 'Patat Oorlog', price: 5.00 },
      { id: 77, name: 'Blikjes Frisdranken', price: 2.50 },
      { id: 78, name: 'Overige Frisdranken', price: 2.50 }
    ]
  },
  {
    id: 'turksePizzaMenus',
    name: { nl: 'Turkse Pizza Menu\'s', en: 'Turkish Pizza Menus' },
    icon: '🍕',
    items: [
      { id: 79, name: 'T.P. Kalfsdöner', price: 13.50 },
      { id: 80, name: 'T.P. Kipdöner', price: 13.00 },
      { id: 81, name: 'T.P. Kaas', price: 10.50 },
      { id: 82, name: 'T.P. Vega', price: 10.50 },
      { id: 83, name: 'T.P. Normaal', price: 9.50 }
    ]
  },
  {
    id: 'otherMenus',
    name: { nl: 'Overige Menu\'s', en: 'Other Menus' },
    icon: '📋',
    items: [
      { id: 84, name: 'Br. Kalfsdöner Menu', price: 12.50 },
      { id: 85, name: 'Br. Kipdöner Menu', price: 12.00 },
      { id: 86, name: 'Dürüm Kalfsdöner Menu', price: 13.50 },
      { id: 87, name: 'Dürüm Kipdöner Menu', price: 13.00 },
      { id: 88, name: '— Bakkerij Items —', price: null },
      { id: 89, name: '— Dranken —', price: null }
    ]
  }
];

export const reviewsData = [
  {
    id: 1,
    name: 'Mohammed A.',
    rating: 5,
    text: { 
      nl: 'Beste kapsalon van heel Holland! Het vlees is vers en heerlijk gekruid.',
      en: 'Best Kapsalon in all of Holland! The meat is fresh and deliciously seasoned.'
    },
    date: '2 weken geleden'
  },
  {
    id: 2,
    name: 'Sarah van D.',
    rating: 5,
    text: {
      nl: 'Het Turkse brood is werkelijk fantastisch. Elke dag vers!',
      en: 'The Turkish bread is truly fantastic. Fresh every day!'
    },
    date: '1 maand geleden'
  },
  {
    id: 3,
    name: 'James K.',
    rating: 5,
    text: {
      nl: 'So far the best place to eat in my NL life. Amazing döner!',
      en: 'So far the best place to eat in my NL life. Amazing döner!'
    },
    date: '3 weken geleden'
  },
  {
    id: 4,
    name: 'Fatima B.',
    rating: 5,
    text: {
      nl: 'Eindelijk een plek met echt halal eten en geweldige service.',
      en: 'Finally a place with real halal food and great service.'
    },
    date: '1 week geleden'
  },
  {
    id: 5,
    name: 'Peter J.',
    rating: 5,
    text: {
      nl: 'The best Turkish pizza I had ever! Zeker een aanrader.',
      en: 'The best Turkish pizza I had ever! Definitely recommended.'
    },
    date: '2 maanden geleden'
  },
  {
    id: 6,
    name: 'Ahmed H.',
    rating: 5,
    text: {
      nl: 'DELICIOUS Turkish Delights! De baklava is hemels.',
      en: 'DELICIOUS Turkish Delights! The baklava is heavenly.'
    },
    date: '1 maand geleden'
  },
  {
    id: 7,
    name: 'Lisa M.',
    rating: 5,
    text: {
      nl: 'Gezellige sfeer en vriendelijk personeel. Top!',
      en: 'Cozy atmosphere and friendly staff. Top!'
    },
    date: '3 weken geleden'
  },
  {
    id: 8,
    name: 'Yusuf O.',
    rating: 5,
    text: {
      nl: 'Best kebab in Alphen! Altijd vers en lekker.',
      en: 'Best kebab in Alphen! Always fresh and delicious.'
    },
    date: '2 weken geleden'
  },
  {
    id: 9,
    name: 'Emma W.',
    rating: 5,
    text: {
      nl: 'De gözleme is heerlijk! Net als in Turkije.',
      en: 'The gözleme is delicious! Just like in Turkey.'
    },
    date: '1 week geleden'
  },
  {
    id: 10,
    name: 'Hassan T.',
    rating: 5,
    text: {
      nl: 'Perfecte plek voor een snelle en lekkere maaltijd.',
      en: 'Perfect place for a quick and tasty meal.'
    },
    date: '4 dagen geleden'
  }
];

export const galleryImages = [
  {
    id: 1,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/luxx6acm_unnamed%20%2838%29.webp',
    alt: 'AK-AL Shop Front'
  },
  {
    id: 2,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/4ze5vqwr_unnamed%20%2839%29.webp',
    alt: 'AK-AL Interior'
  },
  {
    id: 3,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/8hv7hmpf_unnamed%20%2840%29.webp',
    alt: 'Fresh Döner'
  },
  {
    id: 4,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/srcpvony_unnamed%20%2841%29.webp',
    alt: 'Turkish Delights'
  },
  {
    id: 5,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/do6n55yx_unnamed%20%2842%29.webp',
    alt: 'Döner Plate'
  },
  {
    id: 6,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/nfdwanjv_unnamed%20%2843%29.webp',
    alt: 'Fresh Salad Bar'
  },
  {
    id: 7,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/7r82hyp9_20260317_175759.jpg',
    alt: 'Bakery Section'
  },
  {
    id: 8,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/039ocmko_20260317_175804.jpg',
    alt: 'Turkish Sweets'
  },
  {
    id: 9,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/pgzhghyl_20260317_175808.jpg',
    alt: 'Baklava Display'
  },
  {
    id: 10,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/etdtrdsm_20260317_175814.jpg',
    alt: 'Fresh Pastries'
  },
  {
    id: 11,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/bxku0td2_20260317_175819.jpg',
    alt: 'Donuts'
  },
  {
    id: 12,
    src: 'https://customer-assets.emergentagent.com/job_d979dc90-af0b-4d56-bedb-da718efe5edd/artifacts/h4mriga4_20260317_175824.jpg',
    alt: 'Fresh Bread'
  }
];

export const shopInfo = {
  name: 'AK-AL',
  fullName: 'AK-AL Bakkerij & Eethuis',
  address: 'Hooftstraat 78, 2406 GL Alphen aan den Rijn',
  phone: '0172 493 231',
  rating: 4.5,
  reviewCount: '600+',
  hours: {
    open: '08:00',
    close: '22:00',
    days: { nl: 'Elke dag', en: 'Every day' }
  },
  googleMapsUrl: 'https://maps.app.goo.gl/GzmxEDrrFA5fZ9dB6',
  features: ['Halal', 'Dine-in', 'Takeaway', 'Wheelchair Accessible', 'Thuisbezorgd']
};
